import React, { ChangeEvent, useContext, useState } from 'react';

import { useNavigate, useParams } from 'react-router-dom';
import { observer } from 'mobx-react-lite';

import Button from 'components/common/Button/Button';
import PasswordInput from 'components/common/PasswordInput/PasswordInput';
import { notify } from 'components/common/Toast/toast.helpers';
import { RootStoreContext } from 'index';
import { ApplicationRoute } from 'routes/routes.enums';
import PasswordValidationPoints from 'components/common/PasswordValidationPoints/PasswordValidationPoints';
import { ErrorMessage } from 'common/enums/errorMessages.enums';
import { PASSWORD_REQUIREMENTS } from 'constants/password.constants';

import styles from './ResetPasswordPage.module.scss';

const ResetPasswordPage = () => {
  const navigator = useNavigate();
  const { authStore } = useContext(RootStoreContext);
  const {
    authStore: { isLoading },
  } = useContext(RootStoreContext);
  const { token } = useParams();
  const [password, setPassword] = useState<string>('');
  const isValidPassword = !!token && PASSWORD_REQUIREMENTS.every((requirement) => requirement.isValid(password));
  const handleSubmitPassword = async () => {
    if (token && isValidPassword) {
      const { success } = await authStore.resetPassword(password, token);

      if (success) {
        navigator(ApplicationRoute.Login);
      } else {
        notify(ErrorMessage.UnknownError, 'error');
      }
    }
  };
  const handlePasswordChange = (event: ChangeEvent<HTMLInputElement>) => {
    setPassword(event.target.value);
  };

  return (
    <div className={styles.main}>
      <h3 className={styles.title}>Enter Your New Password to Log In</h3>
      <div className={styles.form}>
        <div className={styles.inputs}>
          <PasswordInput
            labelTitle="Password"
            tabIndex={2}
            onChange={handlePasswordChange}
            value={password}
            containerClassName={styles.passwordInputContainer}
          />
          <PasswordValidationPoints password={password} />
          <div className={styles.buttonsLayout}>
            <Button className={styles.button} onClick={handleSubmitPassword} disabled={isLoading} isLoading={isLoading}>
              Submit
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default observer(ResetPasswordPage);
